var company = /** @class */ (function () {
    function company() {
    }
    return company;
}());
export { company };
